import { apiRequest } from './apiClient.js'

export const systemService = {
    ping: (options = {}) => apiRequest('/ping', options),
}
